import { Button, Grid, LinearProgress, Stack, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {
    endOfMonth,
    endOfWeek,
    format,
    startOfMonth,
    startOfWeek,
} from 'date-fns';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { sendJsonData } from '../../../helpers/sendJsonData';
import showMessage from '../../../helpers/showMessage';
import PageHeader from '../includes/PageHeader';

import './archiveGraph.css';
import EpgGraph from './EpgGraph';

export default function ArchiveGraph() {
    const [isLoading, setIsLoading] = useState(true);
    const { enqueueSnackbar } = useSnackbar();
    const [graphDataList, setGraphDataList] = useState([]);
    // const [btnDayVariant, setbtnDayVariant] = useState('contained');
    // const [btnWeekVariant, setbtnWeekVariant] = useState('outlined');
    // const [btnMonthVariant, setbtnMonthVariant] = useState('outlined');
    const end = new Date();
    const today = new Date();
    const [dateData, setDateData] = useState({
        startDate: today,
        endDate: new Date(today.getTime() + 24 * 60 * 60 * 1000),
    });
    const [customStartDate, setCustomStartDate] = useState(today);
    const [customEndDate, setCustomEndDate] = useState(new Date(today.getTime() + 24 * 60 * 60 * 1000));

    useEffect(() => {
        handleSubmit();
    }, [dateData]);

    const handleSubmit = () => {
        const data = {
            startDate: format(dateData.startDate, 'yyyy/MM/dd'),
            endDate: format(dateData.endDate, 'yyyy/MM/dd'),
        };
        sendJsonData(data, 'archive')
            .then((response) => {
                const dataArr = response.data?.data;

                setGraphDataList(dataArr);
                
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            }).finally(() => {
                setIsLoading(false);
            })
    };

    const handleCustomDateSubmit = () => {
        setIsLoading(true);
        setDateData({
            startDate: customStartDate,
            endDate: customEndDate,
        });
    };

    // const handleDayBtn = () => {
    //     setbtnDayVariant('contained');
    //     setbtnWeekVariant('outlined');
    //     setbtnMonthVariant('outlined');
    //     setIsLoading(true);
    //     setDateData({
    //         endDate: new Date(today.getTime() + 24 * 60 * 60 * 1000),
    //         startDate: today,
    //     });
    // };

    // const handleWeekBtn = () => {
    //     setbtnDayVariant('outlined');
    //     setbtnWeekVariant('contained');
    //     setbtnMonthVariant('outlined');
    //     setIsLoading(true);
    //     setDateData({
    //         endDate: endOfWeek(today, { weekStartsOn: 1 }),
    //         startDate: startOfWeek(today, { weekStartsOn: 1 }),
    //     });
    // };

    // const handleMonthBtn = () => {
    //     setbtnDayVariant('outlined');
    //     setbtnWeekVariant('outlined');
    //     setbtnMonthVariant('contained');
    //     setIsLoading(true);
    //     setDateData({
    //         endDate: endOfMonth(today),
    //         startDate: startOfMonth(today),
    //     });
    // };
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container justifyContent="center">
                <PageHeader pageName="Хөтөлбөрийн график" showAddNew={false} />

                {/* <Stack spacing={3} direction="row">
                    <Button
                        variant={btnDayVariant}
                        color="success"
                        onClick={handleDayBtn}
                        autoFocus
                    >
                        Өдөр
                    </Button>
                    <Button
                        variant={btnWeekVariant}
                        color="success"
                        onClick={handleWeekBtn}
                        autoFocus
                    >
                        7 хоног
                    </Button>
                    <Button
                        variant={btnMonthVariant}
                        color="success"
                        onClick={handleMonthBtn}
                        autoFocus
                    >
                        Сар
                    </Button>
                </Stack> */}

                <Stack spacing={3} direction="row" marginTop={3}>
                    <DatePicker
                        label="Хайлтын эхлэх өдөр"
                        value={customStartDate}
                        onChange={(newValue) => setCustomStartDate(newValue)}
                        renderInput={(params) => <TextField {...params} />}
                    />
                    <DatePicker
                        label="Хайлтын дуусах өдөр"
                        value={customEndDate}
                        onChange={(newValue) => setCustomEndDate(newValue)}
                        renderInput={(params) => <TextField {...params} />}
                    />
                    <Button
                        variant="contained"
                        color="success"
                        onClick={handleCustomDateSubmit}
                    >
                        Хайх
                    </Button>
                </Stack>

                {isLoading ? (
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                ) : (
                        
                    <EpgGraph graphData={graphDataList} />
                )}
            </Grid>
        </LocalizationProvider>
    );
}
